import type { HistorySourceTypeConfig } from "./history-source-config";
import type { PlatformHistoryTwins } from "../history-platform-twins";
import { ResourceType } from "@common/types/auditLog";
import { APIProcessName } from "../process-names";
import { HistoryField, HistoryGroupBy } from "./history-fields";

export const CATALOG_ITEM_FIELDS = [
    HistoryField.NAME,
    HistoryField.DESCRIPTION,
    HistoryField.SKU,
    HistoryField.TYPE,
    HistoryField.ACTIVE,
    HistoryField.REVENUE_ACCOUNT_ID,
    HistoryField.RECEIVABLES_ACCOUNT_ID,
    HistoryField.CATALOG_ITEM_CLASS_ASSIGNMENTS,
    HistoryField.PRICES,
];

const CATALOG_ITEM_SOURCES: ReadonlyArray<{
    sourceType: APIProcessName;
    groupBy: HistoryGroupBy.NONE | HistoryGroupBy.FIELD;
    platformTwins: PlatformHistoryTwins;
}> = [
    {
        sourceType: APIProcessName.CATALOG_ITEM_CREATE,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.CATALOG_ITEM_UPDATE,
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.CATALOG_ITEM_DELETE,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.CATALOG_ITEM_DUPLICATE,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.CATALOG_ITEM_ARCHIVE,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.CATALOG_ITEM_ENABLE,
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
    },
];

export const catalogItemSources: HistorySourceTypeConfig[] =
    CATALOG_ITEM_SOURCES.map(({ sourceType, groupBy, platformTwins }) => ({
        sourceType,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.CATALOG_ITEM,
                fields: CATALOG_ITEM_FIELDS,
            },
        ],
        groupBy,
        platformTwins,
        enabled: true,
    }));
